import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { requireNotNull } from '@shared/pipes/require-not-null'
import { ipotekaNerezMainBlock } from 'data/ipotekaNerezMainBlock'
import { IpotekaNerezScreen } from 'screens/ipoteka-nerez'

import {
	RegionalPagesPath,
	regionalPagesProps,
} from '../../../regions/runtime-components/pages-props'
import { serverSideResolveCity } from '../../../ssr-resolvers/next-ssr-resolvers'

const IpotekaNerezPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	IpotekaNerezScreen({
		mainBlockPath: ipotekaNerezMainBlock,
		ratePoints: [
			'Без подтверждения дохода, при первоначальном взносе от 40%',
			'Низкая ставка от 4,5% годовых',
			'Предварительное решение в день одобрения',
			'Быстрый выход на сделку',
			'Доступны льготные программы',
		],
		minLoan: 100000,
		maxLoan: 500000,
		isAutoLoan: false,
	})

const pageProps = requireNotNull(regionalPagesProps[RegionalPagesPath.personalNaIpotekuNerez])
IpotekaNerezPage.layout = pageProps.layout
IpotekaNerezPage.headProps = pageProps.headProps

export const getServerSideProps = serverSideResolveCity

export default IpotekaNerezPage
